import React from 'react'

// reactstrap components
import { Button, Container, Row, Col } from 'reactstrap'

import logoMural from 'assets/img/logo_mural_2.png'

function TermosPage() {
  document.documentElement.classList.remove('nav-open')
  React.useEffect(() => {
    document.body.classList.add('termos-de-uso')
    return function cleanup() {
      document.body.classList.remove('termos-de-uso')
    }
  })

  function goBack() {
    window.history.go(-1)
  }

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-left" md="12">
              <div style={{ textAlign: 'center' }}>
                <h2 className="title" style={{ fontWeight: 600, letterSpacing: 2, marginTop: 50 }}>
                  Termos de Uso 
                </h2>
              </div>

              <div>              
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>1. Descrição da ferramenta</span>
                  <br /> <br />A ferramenta “MURAL de Aprovados SiSU” consiste em uma aplicação gratuita que indica, a
                  partir de uma lista de nomes de alunos, quais deles foram aprovados pela última chamada regular do
                  SiSU divulgada. A ferramenta fornece essas informações de maneira totalmente gratuita, de forma que o
                  uso da aplicação não implica em pagamento ou fechamento de contrato com as empresas que a
                  desenvolveram.
                </p>
                <br />
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>2. Cadastro</span>
                  <br /> <br />
                  Para utilizar a ferramenta, é necessário preencher o formulário disponibilizado na página:
                  http://muralsisu.evolucional.com.br/cadastro.
                </p>
                <br />
                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>3. Lista de aprovados</span>
                  <br /> <br />
                  <span style={{ fontWeight: 600 }}>3.1.</span> Para ter acesso à lista de aprovados, é necessário fazer
                  o upload de uma planilha Excel no formato .xls com os nomes dos alunos que se deseja consultar e que
                  fizeram o último ENEM, conforme indicado na página da ferramenta. Uma vez que a planilha é enviada, o
                  sistema vai fornecer uma lista com as seguintes informações: <br />
                  <br />
                  <ul>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.1.</span> Nome do aluno
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.2.</span> Status (aprovado, não encontrado ou lista de
                      espera)
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.3.</span> Sigla da IES (Instituição de Ensino)
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.4.</span> Nome do curso
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.5.</span> Classificação
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.6.</span> Modalidade
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.1.7.</span> Número de inscrição fornecido pelo sistema
                    </li>
                  </ul>
                  <br />
                  <span style={{ fontWeight: 600 }}>3.2.</span> A consulta dos aprovados se baseia exclusivamente no
                  nome dos alunos. Cada nome da lista é procurado na lista de aprovados de todos os cursos na chamada
                  regular do SiSU. Isso significa que, apesar de pouco provável, pode haver casos de alunos que não
                  foram aprovados, mas que estarão relacionados com algum curso, por terem um homônimo exato. <br />{' '}
                  <br />
                  <ul>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.2.1.</span> Caso haja dois ou mais alunos com nomes iguais
                      entre os aprovados no SiSU, esses alunos estarão sinalizados na lista fornecida para facilitar sua
                      identificação. Você poderá verificar qual aluno é de fato da sua escola a partir do número de
                      inscrição.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.2.2.</span> Se o nome do aluno indicado no arquivo enviado não
                      for o nome completo do estudante, o resultado poderá ser diferente da realidade.
                    </li>
                  </ul>
                  <br />
                  <span style={{ fontWeight: 600 }}>3.3.</span> Os alunos que forem aprovados terão as informações de
                  todas as colunas preenchidas. <br /> <br />
                  <span style={{ fontWeight: 600 }}>3.4.</span> Quando apenas as colunas “Nome do aluno” e “Status”
                  estiverem preenchidas, sendo esta última com a informação “Não encontrado”, tem-se duas
                  possibilidades: <br /> <br />
                  <ul>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.4.1.</span> O aluno em questão não foi aprovado em nenhum
                      curso.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>3.4.2.</span> O nome do aluno apresentado na planilha diverge do
                      nome que o estudante usou no ENEM e, por causa disso, ele não foi encontrado no sistema do SiSU.
                    </li>
                  </ul>
                  <br />
                  <span style={{ fontWeight: 600 }}>3.5.</span> A lista de aprovados fornecida pela ferramenta refere-se
                  à última chamada regular do SiSU publicada. <br /> <br />
                </p>

                <p style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 600 }}>4. Sobre os dados informados.</span>
                  <br /> <br />
                  <ul>
                    <li>
                      <span style={{ fontWeight: 600 }}>4.1.</span> A desenvolvedora da ferramenta se compromete a
                      preservar os resultados tanto da escola quanto dos alunos.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>4.2.</span> A desenvolvedora da ferramenta não se responsabiliza
                      caso alguma escola busque o resultado de alunos matriculados em outras instituições.
                    </li>
                  </ul>
                </p>

               </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default TermosPage
